import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { AllIncomingEvents, isValidIncomingEvent } from './definitions';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class IncomingEventsReceiverService {
  private readonly mobileEventsDebugEnabled = environment.mobileEventsDebugEnabled;

  private incomingEventsSink$ = new Subject<AllIncomingEvents>();

  public incomingEvents$: Observable<AllIncomingEvents> = this.incomingEventsSink$.asObservable();

  public register(): void {
    (window as any).mobileAppEventsReceiver = (event: unknown): void => {
      if (isValidIncomingEvent(event)) {
        if (this.mobileEventsDebugEnabled) {
          console.log('[IncomingEventsReceiverService] Received', event);
        }
        this.incomingEventsSink$.next(event);
      } else {
        console.warn('[IncomingEventsReceiverService] Invalid event received', event);
      }
    };
  }
}
